import { post } from './'
import _map from 'lodash/map'
import {
  getDiamondsForCheckout,
  getJewelryForCheckout,
  getTaxAmount,
  getDepositAmount,
  getSubtotal,
  getGrandTotal
} from '../selectors/summary'
import {
  getDiamondPrices,
  getJewelryPrices
} from '../selectors/cart'

export const sendSessionSummary = (state) => {
  let { markupType, currency } = state.settings
  let { clientNotes, salesNotes, taxPercent } = state.cart
  let req = {
    emails: state.summary.completeSessionForm,
    diamonds: diamondListWithPrices(getDiamondsForCheckout(state), getDiamondPrices(state)),
    jewelry: jewelryListWithPrices(getJewelryForCheckout(state), getJewelryPrices(state)),
    summary: {
      clientNotes,
      salesNotes,
      depositAmount: getDepositAmount(state),
      taxPercent,
      taxAmount: getTaxAmount(state),
      subtotal: getSubtotal(state),
      grandTotal: getGrandTotal(state)
    },
    clientProfile: state.client,
    settings: {
      markupType,
      currency
    }
  }
  return post('/order_summary', req)
}

const diamondListWithPrices = (items, prices) => {
  return _map(items, (value, id) => ({
    id,
    data: value.data,
    price: prices[id]
  }))
}

const jewelryListWithPrices = (items, prices) => {
  return _map(items, (value, id) => {
    let { data, filters, description, appraisalCostInCAD, appraisalCostInUSD, additionalNotes } = value
    return {
      id,
      data,
      filters,
      description,
      price: prices[id],
      appraisalCostInCAD,
      appraisalCostInUSD,
      additionalNotes
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/summary.js